export type GuestLessonProgress = {
  lessonId: string;
  completedLines: number[];
  completedChallengeLines: number[];
  practiceLineProgress: number[];
  challengeLineProgress: number[];
  challengeCompleted: boolean;
  updatedAt: number;
};

const GUEST_LESSON_PROGRESS_STORAGE_KEY = "chesshotel:lesson-progress:v1";

const isClient = () => typeof window !== "undefined";

const readGuestLessonProgressStore = (): Record<string, GuestLessonProgress> => {
  if (!isClient()) {
    return {};
  }

  try {
    const rawValue = window.localStorage.getItem(
      GUEST_LESSON_PROGRESS_STORAGE_KEY,
    );

    if (!rawValue) {
      return {};
    }

    const parsedValue = JSON.parse(rawValue);
    if (!parsedValue || typeof parsedValue !== "object") {
      return {};
    }

    return parsedValue as Record<string, GuestLessonProgress>;
  } catch {
    return {};
  }
};

const writeGuestLessonProgressStore = (
  store: Record<string, GuestLessonProgress>,
) => {
  if (!isClient()) {
    return;
  }

  window.localStorage.setItem(
    GUEST_LESSON_PROGRESS_STORAGE_KEY,
    JSON.stringify(store),
  );
};

export const getGuestLessonProgress = (
  lessonId: string,
): GuestLessonProgress | null => {
  if (!lessonId) {
    return null;
  }

  const store = readGuestLessonProgressStore();
  return store[lessonId] ?? null;
};

export const getAllGuestLessonProgress = (): Record<
  string,
  GuestLessonProgress
> => {
  return readGuestLessonProgressStore();
};

export const saveGuestLessonProgress = (
  progress: Omit<GuestLessonProgress, "updatedAt">,
) => {
  if (!progress.lessonId) {
    return;
  }

  const store = readGuestLessonProgressStore();
  store[progress.lessonId] = {
    ...progress,
    updatedAt: Date.now(),
  };

  writeGuestLessonProgressStore(store);
};
